import { render } from "./HeroiconsOutlineSwitchHorizontal.vue?vue&type=template&id=454e4773"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSwitchHorizontal.vue"]])

export default __exports__